import * as React from 'react'

function SvgVerticalMechanics(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='1em'
      height='1em'
      viewBox='0 0 400.667 400.666'
      {...props}
    >
      <filter filterUnits='objectBoundingBox' id='vertical_mechanics_svg__a'>
        <feGaussianBlur stdDeviation={5} result='blur' in='SourceAlpha' />
        <feOffset result='offsetBlurredAlpha' in='blur' />
        <feMerge>
          <feMergeNode in='offsetBlurredAlpha' />
          <feMergeNode in='SourceGraphic' />
        </feMerge>
      </filter>
      <circle fill='#232323' cx={200.333} cy={200} r={161} />
      <path
        fill='none'
        stroke='#FFF'
        strokeWidth={4}
        strokeMiterlimit={10}
        d='M50.234 200h23.433M94.197 93.864l16.57 16.57M200.333 49.902v23.432M306.468 93.865L289.9 110.434M348.583 223.481l-23.143-3.667M348.583 176.521l-23.143 3.664M306.467 306.137L289.9 289.566M200.332 350.1l.001-23.434M94.196 306.137l16.571-16.571'
      />
      <path
        fill='none'
        stroke='#FFF'
        strokeWidth={2}
        strokeMiterlimit={10}
        d='M50.697 188.224l15.93 1.253M52.082 176.52l15.783 2.499M54.381 164.96l15.538 3.729M57.581 153.616l15.196 4.938M61.66 142.559l14.762 6.115M66.594 131.855l14.237 7.255M72.353 121.572l13.624 8.35M78.9 111.772l12.927 9.393M86.197 102.517l12.15 10.378M50.697 211.777l15.93-1.254M52.083 223.481l15.783-2.501M54.382 235.041l15.538-3.732M57.582 246.384l15.197-4.94M61.661 257.441l14.762-6.117M66.595 268.144l14.238-7.257M72.354 278.427l13.624-8.352M78.902 288.226l12.927-9.395M86.199 297.481l12.149-10.38M112.11 321.432l9.39-12.93M132.192 333.738l7.252-14.239M153.952 342.751l4.935-15.198M176.853 348.25l2.498-15.784M223.814 348.25l-2.502-15.783M246.716 342.751l-4.94-15.196M268.476 333.738l-7.257-14.237M288.558 321.432l-9.394-12.926M321.764 288.227l-12.93-9.391M334.071 268.145l-14.239-7.253M343.084 246.385l-15.198-4.936M343.085 153.621l-15.197 4.94M334.072 131.861l-14.238 7.256M321.765 111.778l-12.927 9.395M288.559 78.572l-9.391 12.93M268.477 66.266l-7.252 14.239M246.717 57.253l-4.935 15.198M223.815 51.754l-2.497 15.784M176.855 51.754l2.502 15.783M153.953 57.252l4.94 15.197M132.193 66.266l7.257 14.236M112.111 78.572l9.394 12.926M337.011 178.353s3 8.314 3 21.98c0 13.167-3 21.315-3 21.315'
      />
      <text
        transform='translate(83.197 208.167)'
        fill='#FFF'
        stroke='#FFF'
        strokeMiterlimit={10}
        fontFamily='sans-serif'
        fontSize={25}
      >
        {'0'}
      </text>
      <path
        fill='none'
        stroke='#FFF'
        strokeWidth={2}
        strokeMiterlimit={10}
        d='M121.417 181.292h-36.25s.342-4.491 2.306-11.307c1.694-5.881 3.944-10.068 3.944-10.068'
      />
      <path
        fill='#FFF'
        stroke='#FFF'
        strokeMiterlimit={10}
        d='M92.042 158.554l-3.875 2.238 4.646 1.938z'
      />
      <path
        fill='none'
        stroke='#FFF'
        strokeWidth={2}
        strokeMiterlimit={10}
        d='M121.417 218.708h-36.25s.342 4.491 2.306 11.307c1.694 5.881 3.944 10.068 3.944 10.068'
      />
      <path
        fill='#FFF'
        stroke='#FFF'
        strokeMiterlimit={10}
        d='M92.042 241.446l-3.875-2.238 4.646-1.938z'
      />
      <text
        transform='translate(125 184.667)'
        fill='#FFF'
        stroke='#FFF'
        strokeWidth={0.5}
        strokeMiterlimit={10}
        fontFamily='sans-serif'
        fontSize={10}
      >
        {'UP'}
      </text>
      <text
        transform='translate(125 222.667)'
        fill='#FFF'
        stroke='#FFF'
        strokeWidth={0.5}
        strokeMiterlimit={10}
        fontFamily='sans-serif'
        fontSize={10}
      >
        {'DOWN'}
      </text>
      <text
        transform='translate(193.66 102.149)'
        fill='#FFF'
        stroke='#FFF'
        strokeWidth={1.5}
        strokeMiterlimit={10}
        fontFamily='sans-serif'
        fontSize={25}
      >
        {'1'}
      </text>
      <text
        transform='translate(192.66 316.498)'
        fill='#FFF'
        stroke='#FFF'
        strokeWidth={1.5}
        strokeMiterlimit={10}
        fontFamily='sans-serif'
        fontSize={25}
      >
        {'1'}
      </text>
      <text
        transform='translate(112.11 131.86)'
        fill='#FFF'
        stroke='#FFF'
        strokeMiterlimit={10}
        fontFamily='sans-serif'
        fontSize={25}
      >
        {'.5'}
      </text>
      <text
        transform='translate(112.11 283.531)'
        fill='#FFF'
        stroke='#FFF'
        strokeMiterlimit={10}
        fontFamily='sans-serif'
        fontSize={25}
      >
        {'.5'}
      </text>
      <text transform='translate(258.848 135.483)'>
        <tspan
          x={0}
          y={0}
          fill='#FFF'
          stroke='#FFF'
          strokeMiterlimit={10}
          fontFamily='sans-serif'
          fontSize={25}
          letterSpacing={-3}
        >
          {'1'}
        </tspan>
        <tspan
          x={10.355}
          y={0}
          fill='#FFF'
          stroke='#FFF'
          strokeMiterlimit={10}
          fontFamily='sans-serif'
          fontSize={25}
        >
          {'.5'}
        </tspan>
      </text>
      <text transform='translate(261.225 281.816)'>
        <tspan
          x={0}
          y={0}
          fill='#FFF'
          stroke='#FFF'
          strokeMiterlimit={10}
          fontFamily='sans-serif'
          fontSize={25}
          letterSpacing={-3}
        >
          {'1'}
        </tspan>
        <tspan
          x={10.355}
          y={0}
          fill='#FFF'
          stroke='#FFF'
          strokeMiterlimit={10}
          fontFamily='sans-serif'
          fontSize={25}
        >
          {'.5'}
        </tspan>
      </text>
      <text
        transform='translate(304.899 208.523)'
        fill='#FFF'
        stroke='#FFF'
        strokeMiterlimit={10}
        fontFamily='sans-serif'
        fontSize={25}
        letterSpacing={-3}
      >
        {'2'}
      </text>
      <text
        transform='translate(143.45 165.69)'
        fill='#FFF'
        stroke='#FFF'
        strokeWidth={0.5}
        strokeMiterlimit={10}
        fontFamily='sans-serif'
        fontSize={14}
      >
        {'VERTICAL SPEED'}
      </text>
      <text
        transform='translate(146.45 242.358)'
        fill='#FFF'
        stroke='#FFF'
        strokeWidth={0.5}
        strokeMiterlimit={10}
        fontFamily='sans-serif'
        fontSize={14}
      >
        {'1000FT PER MIN'}
      </text>
    </svg>
  )
}

export default SvgVerticalMechanics
